import { useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { RichText } from 'prismic-reactjs';

import { testimonialHtmlSerializer } from 'utils/htmlSerializers/testimonialHtmlSerializer';

import { ITestimonialProps } from './interfaces';
import { imageSerializer } from '../../../utils/imageSerializer';
import {
  Author,
  AuthorDetails,
  AuthorName,
  AuthorPicture,
  AuthorPosition,
  Button,
  Content,
  Inner,
  QuoteIcon,
  Section,
  Title,
} from './testimonial.styles';

export const Testimonial = ({
  title,
  quote,
  additionalClassName,
  caseStudy,
  caseImage,
  caseName,
  casePosition,
  titleAs,
}: ITestimonialProps): JSX.Element => {
  const className = classNames('testimonial', additionalClassName);

  const [isShowing, setIsShowing] = useState<boolean>(false);

  const displayButton = quote?.length > 1;

  return (
    <Section className={className}>
      <Inner>
        <Title as={titleAs}>{title}</Title>

        <Content>
          <QuoteIcon type="left" />
          {
            <div
              className={classNames('testimonial__quote', {
                'testimonial__quote--show': isShowing,
              })}
            >
              <RichText
                render={quote}
                htmlSerializer={testimonialHtmlSerializer}
              />
              {displayButton && (
                <Button onClick={() => setIsShowing(!isShowing)}>
                  {isShowing ? 'Less' : 'More'}
                </Button>
              )}
            </div>
          }
          <QuoteIcon type="right" />
        </Content>
        {caseStudy ? (
          <Author className={'short-testimonial__author'}>
            {caseImage && (
              <AuthorPicture>
                <Image {...imageSerializer(caseImage)} />
              </AuthorPicture>
            )}
            <AuthorDetails className={'author__details'}>
              <AuthorName className={'author__name'}>{caseName}</AuthorName>
              <AuthorPosition className={'author__position'}>
                {casePosition}
              </AuthorPosition>
            </AuthorDetails>
          </Author>
        ) : null}
      </Inner>
    </Section>
  );
};
